import '../app/bundles/user/registerClient';

// this is for third party JS content (i.e. calculators)
import React from 'react';
import ReactDOM from 'react-dom';
window.React = React;
window.ReactDOM = ReactDOM;
